import PropTypes from 'prop-types'
import ClientSaveButtons from '@/containers/SubscriptionFormPageNew/Components/SaveButtons/ClientSaveButtons'

/**
 * TopHeader displayed at the top of the 'client' tab. Mirrors the contract
 * TopHeader layout (full-width row, save button anchored top-right).
 */
const ClientTopHeader = ({ hidden = false }) => {
  if (hidden) return null

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
      }}
    >
      <ClientSaveButtons />
    </div>
  )
}

ClientTopHeader.propTypes = {
  hidden: PropTypes.bool,
}

export default ClientTopHeader
